import { render, staticRenderFns } from "./AddForumPage.vue?vue&type=template&id=749d927e"
import script from "./AddForumPage.vue?vue&type=script&lang=js"
export * from "./AddForumPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports